module.exports = __webpack_public_path__ + "static/media/im.d310b7af.svg";